import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';

import AuthReducers from "./authReducers";
import WatchTowerReducer from "./watchTowerReducers";

// MODULE - CONSUMER
import ConsumerReducer from "./consumerReducers";
// SUBMODULE - CONSUMER > PAYMENTS
import ConsumerPaymentReducer from "./consumer[payments]Reducers";
// SUBMODULE - CONSUMER > VIRTUAL_CARDS
import ConsumerVirtualCardsReducer from "./consumer[virtualCards]Reducers";

// MODULE - BUSINESS
import BusinessReducer from "./businessReducers";
// MODULE - BUSINESS > NOTIFICATIONS
import BusinessNotificationsReducer from "./business[notifications]Reducers";
// MODULE - BUSINESS > SUBSCRIPTIONS
import BusinessSubscriptionsReducer from "./business[subscriptions]Reducers";
// MODULE - BUSINESS > IDENTITY
import BusinessIdentityReducer from "./business[identity]Reducers";
// MODULE - BUSINESS > WEBHOOK
import BusinessWebhookReducer from "./business[webhook]Reducers";
// MODULE - BUSINESS > FUSION
import BusinessFusionReducer from "./business[fusion]Reducers";
// MODULE - BUSINESS > FUSION > ORUM
import BusinessFusionOrumReducer from "./business[fusion][orum]Reducers";
// MODULE - BUSINESS > FUSION > WYZIA
import BusinessFusionWyziaReducer from "./business[fusion][wyzia]Reducers";
// MODULE - BUSINESS > FUSION > CC
import BusinessFusionCCReducer from "./business[fusion][cc]Reducers";
// MODULE - BUSINESS > FUSION > ALT
import BusinessFusionALTReducer from "./business[fusion][altcard]Reducers";
// MODULE - BUSINESS > CORE
import BusinessCoreReducer from "./business[core]Reducers";
// MODULE - BUSINESS > CORE > CC
import BusinessCoreCCReducer from "./business[core][cc]Reducers";
// MODULE - BUSINESS > CORE > TRADE DEFENCE
import BusinessCoreTradeDefenceReducer from "./business[core][tradeDefence]Reducers";
// MODULE - BUSINESS > ACCOUNTING TPI > QBD
import BusinessAccountingTPIQBDReducer from "./business[accountingTPI][qbd]Reducers";
// MODULE - BUSINESS > ACCOUNTING TPI > QBO
import BusinessAccountingTPIQBOReducer from "./business[accountingTPI][qbo]Reducers";
// MODULE - BUSINESS > ACCOUNTING TPI > XERO
import BusinessAccountingTPIXeroReducer from "./business[accountingTPI][xero]Reducers";

// MODULE - CERTIFICATION
import CertificationReducer from "./certificationReducers";

// MODULE - SUPPORT
import SupportReducer from "./supportReducers";
// SUBMODULE - SUPPORT > CONFIG
import SupportConfigReducer from "./support[config]Reducers";

import MiscellaneousReducer from "./miscellaneousReducers";

const persistConfig = {
  key: "root",
  storage,
  // Auth state must NOT be persisted — the canonical truth is the HttpOnly
  // cookie. Persisting `isAuthenticated` would let stale Redux state contradict
  // a cleared/expired cookie. Auth is rehydrated by ProtectedRoutes calling /me.
  blacklist: ["auth"],
};

const rootReducer = combineReducers({
  auth: AuthReducers,
  watchTower: WatchTowerReducer,

  consumer: ConsumerReducer,
  "consumer.payments": ConsumerPaymentReducer,
  "consumer.vcn": ConsumerVirtualCardsReducer,

  business: BusinessReducer,
  "business.notifications": BusinessNotificationsReducer,
  "business.subscriptions": BusinessSubscriptionsReducer, 
  "business.identity": BusinessIdentityReducer,
  "business.webhook": BusinessWebhookReducer,
  "business.fusion": BusinessFusionReducer,
  "business.fusion.orum": BusinessFusionOrumReducer,
  "business.fusion.wyzia": BusinessFusionWyziaReducer,
  "business.fusion.cc": BusinessFusionCCReducer,
  "business.fusion.altcard": BusinessFusionALTReducer,
  "business.core": BusinessCoreReducer,
  "business.core.cc": BusinessCoreCCReducer,
  "business.core.tradeDefence": BusinessCoreTradeDefenceReducer,
  "business.accounting-tpi.qbd": BusinessAccountingTPIQBDReducer,
  "business.accounting-tpi.qbo": BusinessAccountingTPIQBOReducer,
  "business.accounting-tpi.xero": BusinessAccountingTPIXeroReducer,

  certification: CertificationReducer,
  
  support: SupportReducer,
  "support.config": SupportConfigReducer,
  
  other: MiscellaneousReducer
});

export default persistReducer(persistConfig, rootReducer);